export const giveawayText = {
  conditionText: 'Syarat',
  minimumPurchaseText: 'Minimum Pembelian',
  requiredProductsWithMinimumPurchaseText: 'Dengan Pembelian',
  requiredProductsText: 'Setiap Pembelian',
};
